import { ReactElement, ComponentType } from 'react';
import { space } from '@op/opds.tokens';
import { Message } from '@messageformat/react';

interface InfoItem {
  icon: ComponentType;
  messageId: string;
}

interface InfoTextBoxProps {
  titleId?: string;
  items: InfoItem[];
}

const InfoTextBox = ({ titleId, items }: InfoTextBoxProps): ReactElement => {
  return (
    <div className="investoracademy-info-text-box-container">
      <div style={{ padding: space.default }}>
        {titleId && (
          <div className="investoracademy-info-text-box-inner-container">
            <h3 className="opds-styles-v1-text-title-small-strong">
              <Message id={titleId} />
            </h3>
          </div>
        )}
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {items.map(({ icon: Icon, messageId }) => (
            <li key={messageId} className="investoracademy-info-text-box-inner-container">
              <Icon />
              <p
                className="opds-styles-v1-text-body-medium"
                style={{ paddingBottom: 0, marginLeft: space.xxs }}
              >
                <Message id={messageId} />
              </p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default InfoTextBox;
